/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractService, CommonService, Config } from '@increff/commons';
import { Observable } from 'rxjs';
import { DOMAIN_SETTINGS, ORGANISATION } from '../../interfaces/organisation.interface';
import { Rest } from '../rest.service';

@Injectable({
    providedIn: 'root'
})
export class OrganisationService {

    constructor(
        private abstractService: AbstractService,
        private urls: Rest,
        private commonService: CommonService,
        private config: Config
    ) { }

    getAppNameFromStorage(): {appName: string} {
        const chosenAppNameStr = localStorage?.getItem(this.commonService?.cipher('lastChosenAppName'));
        if(chosenAppNameStr) return JSON.parse(this.commonService?.decipher(chosenAppNameStr));

        this.setAppNameInStorage('auth');
        return {appName: 'auth'};
    }

    setAppNameInStorage(appName: string): void {
        localStorage?.setItem(this.commonService?.cipher('lastChosenAppName'), this.commonService?.cipher(JSON.stringify({appName})));
    }

    getApplicationDomains(appName: string): Observable<ORGANISATION[]>{
        const params = new HttpParams()?.set('appName', appName);
        return this.abstractService?.exec(this.urls.applicationDomainsUrl, 'GET', undefined, {params, ...this.config?.startupData?.extraHttpOptions});
    }

    addNewApplicationDomain(domainDetails: ORGANISATION): Observable<void> {
        return this.abstractService?.exec(this.urls.addAdminDomainUrl, 'POST', domainDetails, {...this.config?.startupData?.extraHttpOptions});
    }

    getOpenRegistrationDomains(): Observable<ORGANISATION[]> {
        return this.abstractService?.exec(this.urls.allOpenRegistrationsUrl, 'GET', undefined, {...this.config?.startupData?.extraHttpOptions});
    }

    updateDomainSecurityConfig(domainId: number, securityConfig: {autoRegister: boolean; oauthDomains: string}): Observable<void> {
        const params = new HttpParams()?.set('domain', domainId);
        return this.abstractService?.exec(this.urls.updateDomainOauthConfigUrl, 'POST', securityConfig, {params, ...this.config?.startupData?.extraHttpOptions});
    }

    changeApplicationDomainStatus(domainId: number, enabled: boolean = true): Observable<void> {
        const params = new HttpParams()?.set('enabled', enabled);
        return this.abstractService?.exec(this.urls?.getAdminChangeOrgStatusUrl(domainId), 'POST', undefined, {params});
    }

    updateDomainSettings(form: DOMAIN_SETTINGS, domainId: number, type: 'admin' | 'domain' = 'admin'): Observable<void> {
        const params = new HttpParams()?.set('domainId', domainId);
        return this.abstractService?.exec(
            type == 'admin' ? this.urls?.updateAdminDomainSettingsUrl : this.urls?.updateDomainSettingsUrl,
            'POST',
            form,
            {params, ...this.config?.startupData?.extraHttpOptions}
        );
    }

    getUserVerificationReport(): string {
        return this.urls.domainUserVerificationReport;
    }

    uploadUserVerificationMigrationFile(formData: FormData): Observable<Blob> {
        return this.abstractService?.exec(this.urls?.domainUserVerificationFileUploadUrl, 'POST', formData, {responseType: 'application/octet-stream'});
    }
}
